export enum KodataCategory {
  CAFE = '카페',
  BAKERY = '제과제빵',
  DESSERT = '디저트',
  KOREAN = '한식',
  CHINESE = '중식',
  JAPANESE = '일식',
  WESTERN = '양식',
  FUSION = '별식·퓨전요리',
  PUB = '주점',
  CHICKEN = '치킨',
  PIZZA = '피자',
  SNACK = '분식',
  FASTFOOD = '패스트푸드',
  CONVENIENCE = '편의점',
  WHOLESALE_RETAIL = '도소매',
  INTERNET_CAFE = 'pc방',
  LEISURE = '여가·오락',
  EDUCATION = '교육·유아',
  STUDY = '스터디카페·독서실',
  LAUNDRY = '빨래방',
  LIFE = '생활서비스',
}
